import takeRequest from '~/store/takeRequest';
import { put, takeEvery } from 'redux-saga/effects';

import * as PeopleActions from '~/store/people/actions';
import * as FormalizationActions from './actions';

export function* reloadContracts({ meta }) {
  yield put(PeopleActions.getContractsOfPerson.start({ id: meta.payload?.personId }));
  yield put(PeopleActions.getStandaloneContracts.start({ personId: meta.payload?.personId }));
}

export function* formalizationSaga() {
  yield takeRequest(FormalizationActions.getDeeplink);
  yield takeRequest(FormalizationActions.updateAddress);
  yield takeRequest(FormalizationActions.updateAddressGroup);
  yield takeRequest(FormalizationActions.acceptTerms);
  yield takeRequest(FormalizationActions.acceptTermsGroup);
  yield takeRequest(FormalizationActions.getAvailableBanks);
  yield takeRequest(FormalizationActions.getBankAccount);
  yield takeRequest(FormalizationActions.updateBankAccount);

  yield takeEvery(FormalizationActions.acceptTerms.success.toString(), reloadContracts);
  yield takeEvery(FormalizationActions.acceptTermsGroup.success.toString(), reloadContracts);
}
